<template>
    <div class="progress">

        <h2 class="progress__title">{{ $t('Apartments') }} 360</h2>
        <p class="progress__text" v-if="loadingProgress === ''">{{ $t('Loading') }}{{ dots }}</p>
        <p class="progress__text" v-else>{{ $t('Loading') }} {{ loadingProgress }}</p>

        <div class="boxes">
            <div class="box">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div class="box">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div class="box">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div class="box">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "Loading",
    data() {
        return {
            dots: ''
        }
    },
    props: {
        loadingProgress: {
            type: String,
            default: ''
        }
    },
    mounted() {
        this.updateDots()
    },
    methods: {
        updateDots() {
            setTimeout(() => {
                if (this.dots.length < 3) {
                    this.dots += `.`
                } else {
                    this.dots = ``
                }

                this.updateDots()
            }, 1000)
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/Loading.scss';
</style>
